import { Media } from '../../components/ui'
import { StarRating } from './StarRating'
import type { Staff } from '../../types/storefront'

export function StaffCard({ staff }: { staff: Staff }) {
  return (
    <figure className="flex w-40 shrink-0 flex-col items-center gap-3 text-center">
      <div className="h-32 w-32 overflow-hidden rounded-full bg-surface-container-high">
        <Media src={staff.avatar} alt={staff.name} kind="person" />
      </div>
      <figcaption className="flex flex-col items-center gap-1">
        <span className="font-display text-headline-sm text-on-surface">{staff.name}</span>
        {staff.title && (
          <span className="font-label-caps text-label-caps uppercase text-on-surface-variant">{staff.title}</span>
        )}
        <StarRating value={staff.rating} />
      </figcaption>
    </figure>
  )
}
